import React from "react";
import { Helmet } from "react-helmet-async";
import 'bootstrap-icons/font/bootstrap-icons.css';

const About = () => {
  return (
    <div className="container py-5 px-3">
      {/* SEO Meta Tags */}
 

 <Helmet>
  <title>About LuvMarry - Indian Dating, Matrimony & Marriage Platform India</title>
  
  <meta
    name="description"
    content="Learn about LuvMarry, the #1 matrimony website in the India. A 100% free and secure platform to connect Indian singles, NRI brides & grooms for love, serious relationships, and marriage."
  />
  
  <meta
    name="keywords"
    content="About LuvMarry, Indian matrimony USA, marriage platform, free Indian matchmaking, Indian singles USA, desi dating site, Indian brides grooms USA, marriage website USA, trusted Indian matrimony"
  />
  
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://luvmarry.com/AboutUs" />

  {/* Open Graph (Facebook, LinkedIn, etc.) */}
  <meta property="og:title" content="About LuvMarry - Indian Matrimony" />
  <meta 
    property="og:description" 
    content="LuvMarry is a free, secure and user-friendly Indian dating & marriage platform connecting singles and NRIs in the USA for meaningful relationships." 
  />
  <meta property="og:image" content="/LuvMarryLogoPink.png" />
  <meta property="og:url" content="https://luvmarry.com/AboutUs" />
  <meta property="og:type" content="website" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="About LuvMarry - Indian Dating & Marriage Platform USA" />
  <meta 
    name="twitter:description" 
    content="Learn about LuvMarry, the free Indian matrimony and dating platform for singles and NRIs in the USA. 100% secure & trusted for serious relationships." 
  />
  <meta name="twitter:image" content="/LuvMarryLogoPink.png" />
</Helmet>


      {/* Header */}
      <div className="text-center mb-4">
        <img
          src="/LuvMarryLogoPink.png"
          alt="LuvMarry Logo"
          width="60"
          height="60"
          style={{ marginBottom: "10px" }}
        />
        <h1
          className="fw-bold"
          style={{
            color: "#e91e63",
            fontFamily: "'Great Vibes', cursive",
            fontSize: "2.3rem",
          }}
        >
          About Us
        </h1>
        <p className="text-muted">Welcome to LuvMarry</p>
      </div>

      {/* Main Content */}
      <div className="bg-white shadow-lg rounded-4 p-4">
        <section className="mb-4">
          <h2 className="fw-bold text-dark">
            <i className="bi bi-heart-fill text-danger me-2"></i>
            Who We Are
          </h2>
          <p>
            LuvMarry is a marriage and dating platform built to help people 
            connect and find meaningful relationships. Our goal is to create a 
            secure and friendly space for individuals seeking life partners.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="fw-bold text-dark">
            <i className="bi bi-tools text-warning me-2"></i>
            Still in Development
          </h2>
          <p>
            We are currently in the <strong>development phase</strong> and working 
            hard to add more features and improvements. Your feedback and support 
            mean a lot as we build the best experience for you.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="fw-bold text-dark">
            <i className="bi bi-gift-fill text-success me-2"></i>
            100% Free to Use
          </h2>
          <p>
            LuvMarry is currently a <strong>completely free app</strong>. You can 
            sign up, connect with other members, and enjoy all available features 
            without any subscription or fees.
          </p>
        </section>

        <section>
          <h2 className="fw-bold text-dark">
            <i className="bi bi-envelope-fill text-primary me-2"></i>
            Get in Touch
          </h2>
          <p>
            Have questions or suggestions? Reach us at: <br />
            <strong>customercare@luvmarry.com</strong>
          </p>
        </section>
      </div>

      {/* Back Button */}
      <div className="text-center mt-4">
        <a
          href="/"
          className="btn btn-lg px-4"
          style={{
            background: "#e91e63",
            color: "#fff",
            borderRadius: "50px",
            fontWeight: "bold",
          }}
        >
          <i className="bi bi-house-door-fill me-2"></i>Back to Home
        </a>
      </div>
    </div>
  );
};

export default About;
